import axios from 'axios';
import { EXTERNAL_USER_AUTHENTICATE } from '../const/URL';
import { ILoginInput } from '../interfaces/loginInput';
import { ILoginResponse } from '../interfaces/loginResponse';

export const login = (obj: ILoginInput): any => {
  let formData = new FormData();

  formData.append('username', obj.username);
  formData.append('password', obj.password);

  return axios
    .post(EXTERNAL_USER_AUTHENTICATE, formData)
    .then((response: any) => {
      if (response.status !== 200) {
        throw new Error(
          'Something went wrong. please check your credentials and try again.'
        );
      }

      return response.data as ILoginResponse;
    });
};
